export const styles = {
  wrapper: {
    height: "100%",
  },
  closeIcon: {
    color: "text.primary",
  },
  actionButtons: {
    "& .MuiButtonBase-root .MuiTypography-root": {
      padding: "0px 40px !important",
    },
  },
  content: {
    width: "486px",
  },
};
